<template>
  <div>
    <tooltip label="View" type="default" placement="top">
      <a class="button button-table is-small" @click="view()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
    <tooltip label="History" type="default" placement="top">
      <a class="button button-table is-small" @click="history()">
        <i class="fa fa-align-right"></i>
      </a>
    </tooltip>
    <tooltip label="Invoice Simple" type="default" placement="top">
      <a class="button button-table is-small" @click="urlInvoice()" v-if="!this.data.base_id">
        <i class="fa fa-link"></i>
      </a>
    </tooltip>
    <tooltip label="PDF" type="default" placement="top">
      <a class="button button-table is-small" @click="pdf()" v-if="!this.data.base_id">
        <i class="fa fa-file-pdf-o"></i>
      </a>
    </tooltip>
    <tooltip label="Excel" type="default" placement="top">
      <a class="button button-table is-small" @click="xls()" v-if="!this.data.base_id">
        <i class="fa fa-file-excel-o"></i>
      </a>
    </tooltip>
    <tooltip label="Boleto" type="default" placement="top" v-if="$store.state.config.user.generate_boleto">
      <!-- QUANDO BOLETO ESTIVER EMITIDO -->
      <a class="button button-table is-small" @click="boleto()" v-if="this.data.boleto_invoice && this.data.boleto_situacao === 0">
        <i class="fa fa-barcode"></i>
      </a>
      <!-- QUANDO BOLETO ESTIVER ESTORNADO -->
      <a class="button button-table is-small is-warning" @click="boleto()" v-if="this.data.boleto_invoice && this.data.boleto_situacao === 2">
        <i class="fa fa-barcode"></i>
      </a>
      <!-- QUANDO BOLETO ESTIVER PAGO -->
      <a class="button button-table is-small is-success" @click="boleto()" v-if="this.data.boleto_invoice && this.data.boleto_situacao === 1">
        <i class="fa fa-barcode"></i>
      </a>
      <!-- QUANDO BOLETO DER ERRO NA EMISSÃO AUTOMATICA -->
      <a class="button button-table is-small is-danger" @click="boleto()" v-if="this.data.boleto_invoice && this.data.boleto_situacao === 3">
        <i class="fa fa-barcode"></i>
      </a>
    </tooltip>
    <!-- <tooltip :label="parseInt(this.data.protected) == 0 ? 'Protect' : 'Unprotect'" type="default" placement="left" v-if="parseInt(this.data.payment) != 1">
        <a class="button button-table is-small" @click="protect()">
          <i :class="{'fa': true, 'fa-lock': parseInt(this.data.protected) == 0, 'fa-unlock': parseInt(this.data.protected) == 1}"></i>
        </a>
    </tooltip> -->
    <!-- <tooltip label="Refresh" type="default" placement="left" v-if="parseInt(this.data.payment) != 1">
      <a class="button button-table is-small" @click="refresh()">
        <i class="fa fa-refresh"></i>
      </a>
    </tooltip> -->
    <!-- <tooltip label="Edit Payment" type="default">
      <a class="button button-table is-small" @click="edit()">
        <i class="fa fa-edit"></i>
      </a>
    </tooltip>
    <tooltip label="Pay" type="default" placement="left" v-if="parseInt(this.data.payment) != 1">
      <a class="button button-table is-small" @click="pay()">
        <i class="fa fa-usd"></i>
      </a>
    </tooltip>
    <tooltip label="Refresh Pay" type="default" placement="left" v-if="parseInt(this.data.payment) === 1">
      <a class="button button-table is-small" @click="refreshPayment()">
        <i class="fa fa-refresh"></i>
      </a>
    </tooltip>
    <tooltip label="Reverse Payment" type="default" placement="left" v-if="parseInt(this.data.payment) == 1 && parseInt($store.state.config.user.level) <= 3">
      <a class="button button-table is-small" @click="revert()">
        <i class="fa fa-undo"></i>
      </a>
    </tooltip>
    <tooltip label="Merge" type="default" placement="left" v-if="parseInt(this.data.protected) == 0">
      <a class="button button-table is-small" @click="merge()">
        <i class="fa fa-random"></i>
      </a>
    </tooltip>
        <tooltip label="Invoice Simple" type="default" placement="left">
      <a class="button button-table is-small" @click="urlInvoice()" v-if="!this.data.base_id">
        <i class="fa fa-link"></i>
      </a>
    </tooltip>
    <tooltip label="Add Services" type="default">
      <a class="button button-table is-small" @click="addServices()" v-if="parseInt(this.data.payment) === 0">
        <i class="fa fa-plus"></i>
      </a>
    </tooltip>
    <tooltip label="Remove Services" type="default">
      <a class="button button-table is-small" @click="delServices()" v-if="parseInt(this.data.payment) === 0">
        <i class="fa fa-times"></i>
      </a>
    </tooltip> -->
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../../../utils/message'
  import Invoice from './invoice'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip,
      Invoice
    },
    methods: {
      view () {
        let propsData = {
          context: this,
          invoice_id: this.data.id,
          edit: true,
          callback: ''
        }
        Invoice.openInvoice(propsData)
      },
      history () {
        let propsData = {
          context: this,
          invoice_id: this.data.id,
          callback: ''
        }
        Invoice.openHistoryInvoice(propsData)
      },
      pdf () {
        window.location.href = this.$store.state.config.apiURL + '/V2/invoice/pdf/' + this.data.id
      },
      xls () {
        window.location.href = this.$store.state.config.apiURL + '/V2/invoice/xls/' + this.data.id
      },
      boleto () {
        let propsData = {
          context: this,
          invoice: this.data,
          callback: ''
        }
        Invoice.openBoleto(propsData)
      },

      // refresh () {
      //   this.$http.post(this.$store.state.config.apiURL + '/V2/invoice/refresh', {invoices: [this.data.id]}).then((response) => {
      //     let propsData = {
      //       title: 'Success',
      //       message: 'The invoice was successfully refreshed',
      //       type: 'success',
      //       direction: 'down',
      //       duration: 4500,
      //       showCloseButton: true
      //     }
      //     message.openMessage(propsData)
      //     this.$parent.loadData(true)
      //   }, (response) => {
      //     this.message('danger', 'Error', response.body)
      //   })
      // },
      // protect () {
      //   this.$http.post(this.$store.state.config.apiURL + '/V2/invoice/protect', {invoices: [this.data.id]}).then((response) => {
      //     let propsData = {
      //       title: 'Success',
      //       message: 'The invoice protection has been applied',
      //       type: 'success',
      //       direction: 'down',
      //       duration: 4500,
      //       showCloseButton: true
      //     }
      //     message.openMessage(propsData)
      //     this.$parent.loadData(true)
      //   }, (response) => {
      //     this.message('danger', 'Error', response.body)
      //   })
      // },
      // pay () {
      //   let propsData = {
      //     context: this,
      //     invoice: this.data,
      //     currency: this.data.currency,
      //     amount: parseFloat(this.data.value),
      //     callback: 'payCallback'
      //   }
      //   Invoice.openPayInvoice(propsData)
      // },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      urlInvoice (result) {
        // window.open('http://localhost:8000/api/V2/invoice/invoice_simple/' + this.data.customer_id + '/' + this.data.id)
        window.open('https://ezlink.global/ezlink/api/V2/invoice/invoice_simple/' + this.data.customer_id + '/' + this.data.id)
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// InvoicesTableButtons.vue?66170ea1